import React from 'react';
import { motion } from 'framer-motion';

const CompanyIntro = () => {
  return (
    <section className="py-24 bg-white border-y border-slate-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.3em] text-[#91756A] mb-6">Company Introduction</h2>
            <p className="text-3xl md:text-4xl font-bold text-[#4D4C4A] leading-tight mb-8 italic">
              A regional leader in sustainable, efficient, and technology-driven infrastructure solutions.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-6 text-slate-500 text-lg leading-relaxed"
          >
            <p>
              VASTECH is a leading engineering solutions provider specializing in advanced HVAC systems, smart elevators, and 
              intelligent building technologies. Established in Sharjah in 2021, VASTECH has rapidly evolved from an 
              installation-focused firm into a regional leader in sustainable, efficient, and technology-driven infrastructure 
              solutions.
            </p>
            <p>
              With a strong focus on precision engineering, predictive intelligence, and human-centric design, we support the 
              UAE vision for modern, smart, and environmentally responsible buildings.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CompanyIntro;